import { render, staticRenderFns } from "./FileReferencePickerElement.vue?vue&type=template&id=444a075a"
import script from "./FileReferencePickerElement.vue?vue&type=script&lang=ts"
export * from "./FileReferencePickerElement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports